import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Title = styled.h1`
  ${props => props.theme.css.heading2}
  margin: 0 0 30px;
  ${bp('sm')`
    padding: 0 20px;
  `}
`

export const PublicLayout = styled.div`
  padding: 100px 20px;
  max-width: 400px;
  margin: 0 auto;
  ${bp('sm')`
    padding: 40px 20px 60px;
  `}

  .actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    > button {
      min-width: 40%;
      line-height: 20px;
      margin: 10px 5px;
      flex-grow: 1;

      > div {
        padding: 10px 20px;
      }
    }
  }

  button {
    &:hover {
      background: ${props => props.theme.palette.primary.alpha};
      border-color: ${props => props.theme.palette.primary.alpha};
    }
  }
`

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: ${props => props.theme.maxWidth};
  margin: 30px auto 0;
  padding: 30px;
  ${bp('sm')`
    padding: 20px 0;
    flex-wrap: wrap;
  `}
`

export const Content = styled.div`
  flex-grow: 1;
  width: calc(100% - 260px);
  ${bp('sm')`
    margin: 50px 0;
    width: 100%;
  `}
`

// TODO: normalize checkbox component. Move to Form
export const MakeDefault = styled.div`
  width: 100%;
  margin: 0 0 10px;

  label {
    display: flex;
    align-items: center;
    user-select: none;
    cursor: pointer;

    input {
      display: none;
    }

    span {
      height: 14px;
      width: 14px;
      border: 1px solid grey;
      display: inline-block;
      position: relative;
      margin-right: 5px;
    }
  }

  [type=checkbox] {
    &:checked {
      + span {
        background: ${props => props.theme.palette.general.greyDark};

        &::before {
          opacity: 1;
          content: '';
          position: absolute;
          width: 7px;
          height: 3px;
          background: transparent;
          top: 3px;
          left: 1px;
          border: 3px solid ${props => props.theme.palette.general.light};
          border-top: none;
          border-right: none;
          transform: rotate(-45deg);
        }
      }
    }
  }
`
